module.exports = __webpack_public_path__ + "images/related.cfa7e2df.png";